import { Action } from '@/_core/fluxstore/types';
import { StorymapState, SubtaskStatusCategory } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class AddNewEmptyStatus extends Action<StorymapState> {
    public static ACTION_TYPE = 'AddNewEmptyStatus';

    public constructor(public category: SubtaskStatusCategory) {
        super(AddNewEmptyStatus.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: AddNewEmptyStatus): void => {
    if (!state.subtaskStatuses.some(x => x.category == action.category && x.key == null)) {
        state.subtaskStatuses
            .filter(x => x.category == action.category)
            .forEach(x => x.order++);

        state.subtaskStatuses.unshift({
            category: action.category,
            color: null,
            key: null,
            name: null,
            order: 0
        });
    }
};

//@ts-ignore
registerReducer(AddNewEmptyStatus.ACTION_TYPE, reducer);
